import * as R from 'ramda'
import React from 'react'

import { getAuthCookies } from '../../../services/auth.service'
import LoginForm from '../../Templates/LoginLanding/LoginLanding'

// todo - either implement auth on parent component or remove isAuthenticated
interface AuthProviderProps {
	isAuthenticated?: boolean
}

interface AuthProviderState {
	isLoggedIn: boolean
}

const INITIAL_STATE: AuthProviderState = {
	isLoggedIn: false,
}

export const authProvider = <P extends object>(Component: React.ComponentType<P>) => {
	return class AuthProvider extends React.Component<P & AuthProviderProps, AuthProviderState> {
		public readonly state: AuthProviderState = INITIAL_STATE

		public componentDidMount() {
			this.checkForCookies()
		}

		checkForCookies = () => {
			this.setState({
				isLoggedIn: !R.any(R.isNil)(R.values(getAuthCookies())),
			})
		}

		authFailHandler = () => {
			this.setState({
				isLoggedIn: false,
			})
		}

		public render() {
			return this.state.isLoggedIn ? (
				<Component {...this.props} onAuthFail={this.authFailHandler} />
			) : (
				<LoginForm title="Enrollment Portal" />
			)
		}
	}
}
